import React from 'react'

export default function EmptyList() {
    return (
        <div className="col mt-4 nav justify-content-center" >
            <h6 >No hay elementos para mostrar</h6>
        </div>
    );
}